<template>
  <b-overlay
    :show="
      (addItemState && addItemState.loading && addItemState.itemId == item.id && !personalization) ||
      (removeItemState && removeItemState.loading && removeItemState.itemId == item.id && !personalization)
    "
    rounded="sm"
    variant="white"
  >
    <div
      v-if="child && personalization"
      v-testid="{ id: 'sidebar-personalization-item', key: item.id }"
      class="child-product product mt-2"
    >
      <hr class="my-1" />
      <b-row
        v-if="child & personalization && item.product"
        no-gutters
        align-v="center"
        class="justify-content-between"
        style="min-height: 40px"
      >
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="auto">
              <span class="fa-layers fa-fw" style="width: 40px">
                <b-img
                  v-if="item.product.image"
                  :src="require('@/assets/images/tag_icon_grey.png')"
                  alt=""
                  class="fa-stack-2x"
                  width="40px"
                  height="40px"
                  style="opacity: 0.7"
                />
                <fa-icon
                  v-if="!item.customTagOrderInfo"
                  :icon="['far', 'plus-circle']"
                  transform="down-13 right-13 grow-3"
                  class="text-success"
                />
              </span>
            </b-col>
            <b-col class="ml-lg-2" :class="item.customTagOrderInfo ? 'ml-1' : 'ml-2'">
              <h4 v-if="item.customTagOrderInfo" class="m-0">{{ $t('product.personalization') }}</h4>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else class="m-0">
                <b-link
                  @click="item.group && item.group.pet && item.group.pet.name ? addChildItem() : (addPersonalization = !addPersonalization)"
                >
                  <span v-if="itemPersonalizationTitle" v-text="itemPersonalizationTitle"></span>
                  <span v-else>
                    {{ $t('product.add') }} {{ $t('product.personalization') }} {{ $t('product.for') }}
                    {{ $n(isItemPersonalizationDiscounted ? itemPersonalizationDiscountedPrice : itemPersonalizationPrice, 'currency') }}
                  </span>
                </b-link>
              </component>
              <small v-if="!item.customTagOrderInfo" class="m-0 text-secondary">
                <span v-if="item.group && item.group.pet && item.group.pet.name">{{ item.group.pet.name.substr(0, 9) }}</span>
                <span v-else>{{ personalizationName.substr(0, 9) || '[Enter Name]' }}</span> | {{ poPrimaryPhone }}
                <b-collapse id="collapse-4" v-model="addPersonalization" class="mt-1 ml-2">
                  <dp-input
                    id="personalize-name"
                    v-model.trim="personalizationName"
                    name="pet's name"
                    type="text"
                    :placeholder="$t('product.petNamePlaceholder')"
                    :validation-rules="{ noEmojis: true, max: 9 }"
                    vid="petName"
                  />
                  <b-link
                    class="btn btn-sm btn-primary w-100 mt-n2 d-flex align-items-center"
                    :disabled="!personalizationName || personalizationLoading"
                    @click="addChildItem"
                  >
                    <div class="mx-auto">{{ $t('dp.generic.save') }}</div>
                    <div v-if="personalizationLoading" role="status" class="fa-pulse float-right">
                      <fa-icon :icon="['fas', 'spinner']" class="d-flex" />
                      <span class="sr-only">{{ $t('dp.buttons.loading') }}</span>
                    </div>
                  </b-link>
                </b-collapse>
              </small>
              <component
                :is="isSmallScreen ? 'h5' : 'h4'"
                v-else-if="item.customTagOrderInfo.name && item.customTagOrderInfo.phone"
                class="m-0"
              >
                {{ item.customTagOrderInfo.name }} |
                {{ item.customTagOrderInfo.phone }}
              </component>
              <component
                :is="isSmallScreen ? 'h5' : 'h4'"
                v-else-if="item.product.type === 'COLLAR' && item.customTagOrderInfo.phone"
                class="m-0"
              >
                <span v-if="item.group && item.group.pet && item.group.pet.id"
                  >{{ item.group.pet.name }} [{{ item.group.pet.idCode }}]</span
                >
                <span v-else>Pet's [Home<em>Safe</em><sup>&reg;</sup> ID]</span> |
                {{ item.customTagOrderInfo.phone }}
              </component>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="item.customTagOrderInfo" cols="auto">
          <h3 class="m-0 text-right">
            <span
              :style="{
                textDecoration: isItemPersonalizationDiscounted ? 'line-through' : '',
              }"
            >
              {{
                !isItemPersonalizationDiscounted && itemPersonalizationPrice === 0
                  ? $t('product.free')
                  : $n(itemPersonalizationPrice, 'currency')
              }}
            </span>
            <span v-if="item.product.personalization && isItemPersonalizationDiscounted" class="ml-1">
              <span v-if="itemPersonalizationDiscountedPrice > 0"> {{ $n(itemPersonalizationDiscountedPrice, 'currency') }} </span>
              <span v-else>{{ $t('totals.free') }}</span>
            </span>
          </h3>
          <b-button v-if="remove" v-testid="'sidebar-personalization-remove-action'" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{
            $t('product.remove')
          }}</b-button>
        </b-col>
      </b-row>
    </div>

    <div v-else-if="child && walletCard" class="child-product product mt-2">
      <hr class="my-1" />
      <b-row v-if="item.product" no-gutters align-v="center" class="justify-content-between" style="min-height: 40px">
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-end">
            <b-col cols="auto">
              <b-img v-if="item.id" :src="require('@/assets/images/wallets/paw_card.png')" width="40px" height="40px" alt="" />
            </b-col>
            <b-col class="ml-lg-2 ml-1" :class="isSmallScreen ? 'ml-2' : ''">
              <h4 class="m-0">{{ $t('basket.walletCard.duplicate') }}</h4>
            </b-col>
            <b-col cols="12" class="col-md-auto">
              <h3 class="m-0 text-right">
                <span v-if="Number(item.subtotal) !== Number(walletCardPrice)" style="text-decoration: line-through">
                  <span v-if="item.discount === 0">{{ $n(walletCardPrice, 'currency') }}</span>
                  <span v-else>{{ $n(item.subtotal, 'currency') }}</span>
                </span>
                <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                  <span v-if="Number(item.subtotal - item.discount) > 0">
                    {{ $n(item.subtotal - item.discount, 'currency') }}
                  </span>
                </span>
              </h3>
              <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">
                {{ $t('product.remove') }}
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>

    <div v-else-if="child && item.product && 'SUBSCRIPTION' === item.product.type" class="child-product mt-2">
      <PetTrackingDeviceSubscriptionProduct
        :product-description="item.product.description"
        :product-name="null"
        :product-price="$n(item.subtotal - item.discount, 'currency')"
        :subscription-interval="item.product.subscriptionInterval"
        :subscription-interval-count="item.product.subscriptionIntervalCount"
      />
    </div>

    <div
      v-else-if="child"
      class="child-product product"
      :hidden="!item.product || item.product.name == 'Standard Split Ring'"
      v-testid="
        item.product && item.product.type === 'PET_ESSENTIALS'
          ? { id: 'sidebar-glowtag-item', key: item.id }
          : item.product && item.product.type === 'CONNECTOR'
          ? { id: 'sidebar-connector-item', key: item.id }
          : null
      "
    >
      <hr class="my-1" />
      <b-row v-if="item.product" no-gutters align-v="center" class="justify-content-between" style="min-height: 40px">
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between">
            <b-col cols="auto" class="mr-1">
              <span class="fa-layers fa-fw" style="width: 40px">
                <b-img
                  v-if="item.product.image"
                  :src="getImage(item.product.image.original)"
                  alt=""
                  class="fa-stack-2x"
                  width="40px"
                  height="40px"
                  style="opacity: 0.7"
                />
                <fa-icon
                  v-if="(orderId && !item.id) || !item.parent"
                  :icon="['far', 'plus-circle']"
                  transform="down-13 right-13 grow-3"
                  class="text-success"
                />
              </span>
            </b-col>
            <b-col class="ml-1 ml-lg-2">
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.id || (!orderId && item.parent)" class="m-0 pl-lg-0">
                <span v-if="!item.keyChain">{{ item.product.name }}</span>
                <span v-else>{{ $t('product.matchingKeychain') }}</span>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.product.type === 'CONNECTOR'" class="m-0">
                <b-link @click="addChildItem">{{ $t('product.upgradeTo') }} {{ item.product.name }} {{ $t('product.for') }} {{ $n(item.product.price, 'currency') }}</b-link>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.product.type === 'PET_ESSENTIALS'" class="m-0 py-2">
                <b-link v-testid="'sidebar-glowtag-add-action'" @click="addChildItem">{{ $t('product.addGlowTag') }} {{ $n(item.product.price, 'currency') }}</b-link>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-else-if="item.keyChain" class="m-0 py-2">
                <b-link @click="addChildItem"
                  >{{ $t('product.addMatchingKeychain') }} {{ $n(item.product.keyChainDiscountedPrice || item.product.keyChainPrice, 'currency') }}
                </b-link>
              </component>
            </b-col>
          </b-row>
        </b-col>
        <b-col v-if="item.id || (!orderId && item.parent)" cols="auto">
          <h3 class="m-0 text-right">
            <span
              :style="{
                textDecoration:
                  Number(item.product[!item.keyChain ? 'price' : 'keyChainPrice']) !== Number(item.subtotal - item.discount)
                    ? 'line-through'
                    : '',
              }"
            >
              {{ $n(item.product[!item.keyChain ? 'price' : 'keyChainPrice'], 'currency') }}
            </span>
            <span
              v-if="Number(item.product[!item.keyChain ? 'price' : 'keyChainPrice']) !== Number(item.subtotal - item.discount)"
              class="ml-1"
            >
              <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
              <span v-else>{{ $t('totals.free') }}</span>
            </span>
          </h3>
          <b-button
            v-if="remove && item.product.sku !== 'FREE_STICKER'"
            variant="link"
            class="m-0 p-0 text-right"
            block
            v-testid="item.product && item.product.type === 'PET_ESSENTIALS' ? 'sidebar-glowtag-remove-action' : item.product && item.product.type === 'CONNECTOR' ? 'sidebar-connector-remove-action' : null"
            @click="removeThisItem"
          >
            {{ $t('product.remove') }}
          </b-button>
        </b-col>
      </b-row>
    </div>

    <div class="product" v-else-if="item.product && 'PET_TRACKING_DEVICE' === item.product.type">
      <PetTrackingDeviceProduct
        :order-item-id="item.id"
        :product-name="item.product.name"
        :product-image-url="item.product.image ? getImage(item.product.image.original) : null"
        :product-price="$n(item.subtotal - item.discount, 'currency')"
        @remove-item="removeThisItem"
      />
      <hr />
      <product
        v-for="childItem in childItems"
        :key="childItem.id"
        :item="childItem"
        :locale="locale"
        :order="order"
        :order-id="orderId"
        :add-item-state="addItemState"
        :remove-item-state="removeItemState"
        :glow-tag-products="glowTagProducts"
        :connector-products="connectorProducts"
        child
      />
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div class="product" v-else-if="item.product && 'SUBSCRIPTION' === item.product.type && item.product.productSubType === 'MEMBERSHIP' ">
      <MembershipSubscriptionProduct
          :item="item"
          :product-image-url="item.product.image ? getImage(item.product.image.original) : null"
          @remove-item="removeThisItem"
      />
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div
      v-else-if="
        ['LICENCE', 'LATE_FEE', 'DONATION', 'REPLACEMENT_TAG'].includes(item.product.type) ||
        vs ||
        noNewTag ||
        (item.product && 'ADDITIONAL_FEE' === item.product.type && 'pet' === item.product.subType)
      "
      class="license-product product pl-0 pr-1"
      :class="{ 'pb-3': last }"
    >
      <b-row no-gutters align-v="center">
        <b-col>
          <h3 class="m-0 pr-2 pl-4">
            <span v-html="tagProductName"></span> {{ vsExpirationDateProductFormat(item.product) }}
            <span v-if="item.quantity > 1">{{ `(x${item.quantity})` }}</span>
          </h3>
        </b-col>
        <b-col cols="auto">
          <h3 class="m-0 text-right">{{ $n(item.subtotal, 'currency') }}</h3>
          <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">
            {{ $t('product.remove') }}
          </b-button>
        </b-col>
      </b-row>
      <hr v-if="!last" />

      <div v-if="last && licensingTotal > 0">
        <b-row>
          <b-col>
            <hr />
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="auto">
            <h3 class="m-0 pr-2 pl-4 font-weight-bold">{{ $t('product.totalLicensingFees') }}</h3>
          </b-col>
          <b-col>
            <h3 class="m-0 text-right">{{ $n(licensingTotal, 'currency') }}</h3>
          </b-col>
        </b-row>
      </div>
    </div>

    <div v-else-if="['PET_TAG', 'DESIGNER_TAG'].includes(item.product.type)" v-testid="{ id: 'sidebar-tag-item', key: item.id }" class="tag-product product pl-1 pl-lg-2 pr-1">
      <b-row no-gutters align-v="start">
        <b-col cols="auto">
          <b-link :href="productSelectionLink">
            <b-img
              v-if="item.product.image"
              :src="getImage(item.product.image.original)"
              alt=""
              class="d-none d-md-block"
              width="90px"
              height="90px"
              v-testid="{ id: 'sidebar-tag-image', key: item.id }"
            />
            <b-img
              v-if="item.product.image"
              :src="getImage(item.product.image.original)"
              alt=""
              class="d-block d-md-none"
              width="60px"
              height="60px"
              v-testid="{ id: 'sidebar-tag-image', key: item.id }"
            />
          </b-link>
        </b-col>
        <b-col class="ml-2">
          <b-row no-gutters align-v="start" class="justify-content-between">
            <b-col>
              <component :is="isSmallScreen ? 'h4' : 'h3'" v-testid="{ id: 'sidebar-tag-name-message', key: item.id }" class="m-0 product-name mb-1">
                <span class="mr-1" v-html="tagProductName"></span>
                <span
                  v-if="item.orderItemBundle && item.orderItemBundle.badge"
                  :style="{ color: item.orderItemBundle.badge.color, backgroundColor: item.orderItemBundle.badge.backgroundColor }"
                  class="badge px-2 py-1"
                >
                  {{ item.orderItemBundle.badge.text }}
                </span>
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" v-testid="{ id: 'sidebar-tag-size-message', key: item.id }" class="m-0">
                {{ $t('product.size') }}
                {{
                  item.product.size === '1/S' ? $t('product.small') : item.product.size === '3/L' ? $t('product.large') : $t('product.na')
                }}
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0" hidden>
                {{ $t('product.color') }} {{ item.product.color ? item.product.color : $t('product.na') }}
              </component>
              <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0">{{ $t('product.splitRingConnectorInc') }}</component>
            </b-col>
            <b-col cols="auto">
              <h3 v-testid="{ id: 'sidebar-tag-price-message', key: item.id }" class="m-0 text-right">
                <span v-if="isItemFree">{{ $t('totals.free') }}</span>
                <template v-else>
                  <span
                    :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }"
                  >
                    {{ $n(item.product.price, 'currency') }}
                  </span>
                  <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                    <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
                    <span v-else>{{ $t('totals.free') }}</span>
                  </span>
                </template>
              </h3>
              <b-button v-if="edit" variant="link" class="m-0 p-0 text-right" block :href="editSelectionLink">{{
                $t('product.edit')
              }}</b-button>
              <b-button v-if="remove" v-testid="'sidebar-tag-remove-action'" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{
                $t('product.remove')
              }}</b-button>
            </b-col>
          </b-row>
          <product
            :item="item"
            :locale="locale"
            :order="order"
            :order-id="orderId"
            :add-item-state="addItemState"
            :remove-item-state="removeItemState"
            child
            personalization
            remove
            @remove-bundle="$emit('remove-bundle')"
            @removeItem="$emit('removeItem', $event)"
            @addChildItem="$emit('addChildItem', { ...$event, parentItem: item })"
          />
          <product
            v-for="childItem in childItems"
            :key="childItem.id"
            :item="childItem"
            :locale="locale"
            :order="order"
            :order-id="orderId"
            :add-item-state="addItemState"
            :remove-item-state="removeItemState"
            :glow-tag-products="glowTagProducts"
            :connector-products="connectorProducts"
            child
            remove
            @remove-bundle="$emit('remove-bundle')"
            @removeItem="$emit('removeItem', $event)"
            @addChildItem="$emit('addChildItem', { ...$event, parentItem: item })"
          />
        </b-col>
      </b-row>
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div v-else-if="['COLLAR'].includes(item.product.type)" class="pet-products product pl-2 pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto">
          <b-link :href="productSelectionLink" :aria-label="item.product.name">
            <b-img v-if="item.product.image" :src="getImage(item.product.image.original)" alt="" class="img-border product-image" />
          </b-link>
        </b-col>
        <b-col>
          <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 pl-3 pr-3 product-name mb-1" v-text="item.product.name" />
          <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0 pl-3 pr-3">
            {{ $t('Color') }}: {{ item.product.color ? item.product.color : 'N/A' }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" class="m-0 pl-3 pr-3">Size: {{ size(item.product.size) }}</component>
        </b-col>
        <b-col :cols="isSmallScreen ? 12 : 'auto'">
          <h3 class="m-0 text-right" :class="{ 'mt-2': isSmallScreen }">
            <span :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }">
              {{ $n(item.product.price, 'currency') }}
            </span>
            <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
              <span v-if="Number(item.subtotal - item.discount) > 0">{{ $n(item.subtotal - item.discount, 'currency') }}</span>
              <span v-else>{{ $t('totals.free') }}</span>
            </span>
          </h3>
          <b-button variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">{{ $t('product.remove') }}</b-button>
        </b-col>
      </b-row>
      <product
        v-for="childItem in item.children"
        :key="childItem.id"
        :item="childItem"
        :locale="locale"
        :order="order"
        :order-id="orderId"
        :remove-item-state="removeItemState"
        child
        remove
        @removeItem="$emit('removeItem', $event)"
      />
      <product
        v-if="item.customization || item.customTagOrderInfo"
        :item="item"
        :locale="locale"
        :order="order"
        :order-id="orderId"
        :remove-item-state="removeItemState"
        child
        personalization
        remove
        @removeItem="$emit('removeItem', $event)"
      />
      <hr v-if="!last" class="hr-lg" />
    </div>

    <div v-else-if="additional" class="additional-product product pr-1">
      <b-row no-gutters align-v="center">
        <b-col cols="auto" class="pl-2">
          <b-link :href="productSelectionLink" :aria-label="item.product.name">
            <b-img v-if="item.product.image" :src="getImage(item.product.image.original)" alt="" class="img-border product-image" />
          </b-link>
        </b-col>
        <b-col>
          <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 pl-3 pr-3 product-name mb-1" v-text="item.product.name" />
          <component
            :is="isSmallScreen ? 'h5' : 'h4'"
            v-if="item.product && ['COLLAR', 'LEASH', 'PET_ESSENTIALS'].includes(item.product.type) && item.product.color"
            class="m-0 pl-3 pr-3"
          >
            {{ $t('Color') }}: {{ item.product.color }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.product && ['COLLAR'].includes(item.product.type)" class="m-0 pl-3 pr-3">
            {{ $t('product.size') }}: {{ size(item.product.size) }}
          </component>
          <component :is="isSmallScreen ? 'h5' : 'h4'" v-if="item.product && ['LEASH'].includes(item.product.type)" class="m-0 pl-3 pr-3">
            {{ $t('dp.generic.length') }}: {{ item.product.length }}
          </component>
          <component
            :is="isSmallScreen ? 'h5' : 'h4'"
            v-if="item.product && ['PET_ESSENTIALS'].includes(item.product.type) && item.product.size"
            class="m-0 pl-3 pr-3"
          >
            {{ $t('product.size') }}: {{ petEssentialsSize(item.product.size) }}
          </component>
          <div v-if="!isSmallScreen && item.product && ['PET_ESSENTIALS'].includes(item.product.type)" class="mt-1 ml-3">
            <span style="border: 1px solid lightgrey; border-radius: 8px; padding: 2px 10px 2px 10px">
              <span class="text-light font-weight-bold" style="cursor: pointer" @click="decrementQty()">-</span>
              <span class="text-dark px-3">{{ item.product.quantity }}</span>
              <span class="text-light font-weight-bold" style="cursor: pointer" @click="incrementQty(item)">+</span>
            </span>
          </div>
        </b-col>
        <b-col :cols="isSmallScreen ? 12 : 'auto'" :class="isSmallScreen ? 'd-flex align-items-center mt-2' : ''">
          <div v-if="isSmallScreen && item.product && ['PET_ESSENTIALS'].includes(item.product.type)" class="ml-2">
            <span style="border: 1px solid lightgrey; border-radius: 8px; padding: 6px 20px 6px 20px">
              <span class="text-light font-weight-bold ml-0 mr-auto" style="cursor: pointer" @click="decrementQty()">-</span>
              <span class="text-dark px-4">{{ item.product.quantity }}</span>
              <span class="text-light font-weight-bold mr-0 ml-auto" style="cursor: pointer" @click="incrementQty(item)">+</span>
            </span>
          </div>
          <div class="ml-auto">
            <h3
              class="m-0 text-right"
              :class="{ 'mt-2': isSmallScreen && (!item.product || !['PET_ESSENTIALS'].includes(item.product.type)) }"
            >
              <span
                :style="{
                  textDecoration: Number(item.product.totalQtyPrice) !== Number(item.product.totalQtyDiscountedPrice) ? 'line-through' : '',
                }"
              >
                {{ $n(item.product.totalQtyPrice, 'currency') }}
              </span>
              <span v-if="Number(item.product.totalQtyPrice) !== Number(item.product.totalQtyDiscountedPrice)" class="ml-1">
                <span v-if="Number(item.product.totalQtyDiscountedPrice) > 0">
                  {{ $n(item.product.totalQtyDiscountedPrice, 'currency') }}
                </span>
                <span v-else>{{ $t('totals.free') }}</span>
              </span>
            </h3>
            <b-button
              v-if="remove"
              variant="link"
              class="m-0 p-0 text-right"
              block
              @click="removeThisItem({ quantity: Number(item.product.quantity) || 1 })"
            >
              {{ $t('product.remove') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
      <product
        v-for="childItem in item.children"
        :key="childItem.id"
        :item="childItem"
        :locale="locale"
        :order="order"
        :order-id="orderId"
        :remove-item-state="removeItemState"
        child
        remove
        @removeItem="$emit('removeItem', $event)"
      />
      <product
        v-if="item.customization"
        :item="item"
        :locale="locale"
        :order="order"
        :order-id="orderId"
        :remove-item-state="removeItemState"
        child
        personalization
        @removeItem="$emit('removeItem', $event)"
      />
      <hr v-if="!last" />
    </div>
    <div v-else-if="walletCard" class="wallet-card-product product pl-1 pl-lg-2 pr-1">
      <b-row no-gutters align-v="start">
        <b-col cols="auto">
          <b-img
            v-if="item.product.image"
            :src="getImage(item.product.image.original)"
            alt=""
            class="d-none d-md-block img-border"
            height="90px"
            width="90px"
          />
          <b-img
            v-if="item.product.image"
            :src="getImage(item.product.image.original)"
            alt=""
            class="d-block d-md-none img-border"
            height="60px"
            width="60px"
          />
        </b-col>
        <b-col>
          <b-row no-gutters align-v="center" class="justify-content-between" :class="!isSmallScreen ? ' my-3' : ''">
            <b-col class="ml-4">
              <component :is="isSmallScreen ? 'h4' : 'h3'" class="m-0 product-name">
                <span class="mr-1">{{ $t('basket.walletCard.petIdentification') }}</span>
                <span
                  v-if="item.orderItemBundle && item.orderItemBundle.badge"
                  :style="{ color: item.orderItemBundle.badge.color, backgroundColor: item.orderItemBundle.badge.backgroundColor }"
                  class="badge px-2 py-1"
                >
                  {{ item.orderItemBundle.badge.text }}
                </span>
              </component>
            </b-col>
            <b-col cols="auto">
              <h3 class="m-0 text-right">
                <span
                  :style="{ textDecoration: Number(item.product.price) !== Number(item.subtotal - item.discount) ? 'line-through' : '' }"
                >
                  {{ $n(item.product.price, 'currency') }}
                </span>
                <span v-if="Number(item.product.price) !== Number(item.subtotal - item.discount)" class="ml-1">
                  <span v-if="Number(item.subtotal - item.discount) > 0">
                    {{ $n(item.subtotal - item.discount, 'currency') }}
                  </span>
                </span>
              </h3>
              <b-button v-if="remove" variant="link" class="m-0 p-0 text-right" block @click="removeThisItem">
                {{ $t('product.remove') }}
              </b-button>
            </b-col>
          </b-row>
          <product
            v-for="childItem in item.children"
            :key="childItem.id"
            :item="childItem"
            :locale="locale"
            :order="order"
            :order-id="orderId"
            :remove-item-state="removeItemState"
            :wallet-card-price="item.product.price"
            class="ml-2"
            child
            remove
            wallet-card
            @removeItem="$emit('removeItem', $event)"
          />
        </b-col>
      </b-row>
      <hr v-if="!last" class="hr-lg" />
    </div>
    <automated-discount-notice v-if="showAutomatedDiscountNotice && item.automatedDiscountState === 'APPLIED'" :label="automatedDiscountLabel" />
    <div ref="confirmationModal"></div>
  </b-overlay>
</template>

<script>
import Vue from 'vue';
import DpInput from '@/components/library/Input';
import Product from '@/components/basket/Product';
import getImage from '@/mixins/getImage';
import {
  DpVsTagExpirationDateMixin,
  DpConfirmationModal,
  DpHomeSafeBrandingMixin,
  DpSurveySubscriptionModal,
  DpShouldShowSurvey,
  DP_MEMBERSHIP_REMOVAL_SURVEY_URL,
  DP_MEMBERSHIP_REMOVAL_SURVEY_ID,
  DP_DESIGNER_TAG_REMOVAL_SURVEY_URL,
  DP_DESIGNER_TAG_REMOVAL_SURVEY_ID,
  DpAutomatedDiscountNotice as AutomatedDiscountNotice,
  DpAutomatedDiscountLabelArgs,
  DpIsPersonalizationDiscounted,
  DpPersonalizationEffectivePrice,
  DpPersonalizationRetailPrice,
} from '@docupet/component-library';
import PetTrackingDeviceSubscriptionProduct from '@/components/basket/PetTrackingDeviceSubscriptionProduct.vue';
import PetTrackingDeviceProduct from '@/components/basket/PetTrackingDeviceProduct.vue';
import MembershipSubscriptionProduct from "@/components/basket/MembershipSubscriptionProduct.vue";

export default {
  name: 'Product',
  components: {
    PetTrackingDeviceProduct,
    PetTrackingDeviceSubscriptionProduct,
    MembershipSubscriptionProduct,
    AutomatedDiscountNotice,
    Product,
    DpInput,
    // eslint-disable-next-line vue/no-unused-components
    DpConfirmationModal,
    // eslint-disable-next-line vue/no-unused-components
    DpSurveySubscriptionModal,
  },
  mixins: [getImage, DpVsTagExpirationDateMixin, DpHomeSafeBrandingMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
    last: {
      type: Boolean,
      required: false,
      default: false,
    },
    child: {
      type: Boolean,
      required: false,
      default: false,
    },
    personalization: {
      type: Boolean,
      required: false,
      default: false,
    },
    additional: {
      type: Boolean,
      required: false,
      default: false,
    },
    vs: {
      type: Boolean,
      required: false,
      default: false,
    },
    noNewTag: {
      type: Boolean,
      required: false,
      default: false,
    },
    remove: {
      type: Boolean,
      required: false,
      default: false,
    },
    edit: {
      type: Boolean,
      required: false,
      default: false,
    },
    locale: {
      type: String,
      required: true,
      default: 'en_US',
    },
    order: {
      type: Object,
      required: true,
      default: null,
    },
    orderId: {
      type: [String, Number],
      required: false,
      default: null,
    },
    removeItemState: {
      type: Object,
      required: true,
      default: null,
    },
    addItemState: {
      type: Object,
      required: false,
      default: null,
    },
    connectorProducts: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    glowTagProducts: {
      type: [Object, Array],
      required: false,
      default: null,
    },
    licensingTotal: {
      type: Number,
      required: false,
      default: 0.0,
    },
    walletCard: {
      type: Boolean,
      required: false,
      default: false,
    },
    walletCardPrice: {
      type: [Number, String],
      required: false,
      default: 0.0,
    },
  },
  data() {
    return {
      addPersonalization: false,
      personalizationLoading: false,
      personalizationName: '',
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    showAutomatedDiscountNotice() {
      if (this.personalization) {
        return false;
      }

      return !this.child || this.item?.parent?.automatedDiscountState !== 'APPLIED';
    },
    automatedDiscountLabel() {
      return this.$t(...DpAutomatedDiscountLabelArgs(this.item, 'product.automatedDiscountLabel'));
    },
    tagProductName() {
      return this.formatHomeSafeText(this.item?.product?.name);
    },
    productSelectionLink() {
      const baseURL = this.$store.getters.generateFullUrl(`/${this.orderId ? `order/${this.orderId}/` : ''}store`)
      const productStyleId = this.item?.product?.style?.id;
      const productGroupId = this.item?.product?.style?.productGroups?.[0]?.id;
      switch (this.item.product.type) {
        case 'DESIGNER_TAG':
          if (productStyleId) {
            return `${baseURL}/tags/style/${productStyleId}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'COLLAR':
          if (productGroupId) {
            return `${baseURL}/collars/style/${productGroupId}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'LEASH':
          if (productGroupId) {
            return `${baseURL}/leashes/style/${productGroupId}`;
          }
        // eslint-disable-next-line no-fallthrough
        case 'PET_ESSENTIALS':
          if (productStyleId && productGroupId) {
            return `${baseURL}/essentials/group/${productGroupId}/style/${productStyleId}`;
          }
        // eslint-disable-next-line no-fallthrough
        default:
          return 'javascript:void(0)';
      }
    },
    editSelectionLink() {
      return this.orderId && this.item?.product?.style?.id
        ? this.$store.getters.generateFullUrl(`/order/${this.orderId}/store/tags/pet/${this.item?.group?.pet?.id}/style/${this.item?.product?.style?.id}?etid=${this.item?.id}`)
        : 'javascript:void(0)';
    },
    poPrimaryPhone() {
      return (
        this.order?.petOwner?.primaryPhone ||
        this.order?.city?.customerService?.phoneNumber?.toString()?.replaceAll('-', '')?.substring(1) ||
        ''
      );
    },
    childItems() {
      if (this.child) return;
      let hasGlowTag = false;
      let hasConnector = false;
      let hasKeyChain = !(Number(this.item?.product?.keyChainPrice) > 0);
      const childItems = [...this.item?.children];
      childItems?.forEach((child) => {
        if (child?.product?.type === 'CONNECTOR' && child.product?.id !== '207') {
          hasConnector = true;
        }
        if (['3284', '3290', '3291'].includes(child?.product?.id)) {
          hasGlowTag = true;
        }
        if (child?.keyChain) {
          hasKeyChain = true;
        }
      });
      if (hasConnector && hasGlowTag && hasKeyChain) return childItems;
      if (!hasConnector && this.connectorProducts?.length) {
        const secureClipConnector = this.connectorProducts?.find((p) => p.name === 'Secure Clip');
        childItems.push({
          id: null,
          product: secureClipConnector,
        });
      }
      if (
        !hasGlowTag &&
        this.glowTagProducts &&
        (!this.item?.product?.laserPrinterJig?.shape || this.item?.product?.laserPrinterJig?.shape === 'RND')
      ) {
        const glowTagProductId = this.getGlowTagProductId();
        const glowTagProduct = this.glowTagProducts?.[`Product_${glowTagProductId}`];
        if (glowTagProduct?.id && glowTagProduct.status !== 'O') {
          childItems.push({
            id: null,
            product: glowTagProduct,
          });
        }
      }
      if (!hasKeyChain) {
        childItems.push({
          id: null,
          product: this.item?.product,
          keyChain: true,
        });
      }
      return childItems;
    },
    isSmallScreen() {
      return window.innerWidth < 450;
    },
    itemPersonalizationTitle() {
      return this.getPersonalizationAddon?.title;
    },
    itemPersonalizationPrice() {
      return DpPersonalizationRetailPrice(this.item);
    },
    itemPersonalizationDiscountedPrice() {
      return DpPersonalizationEffectivePrice(this.item);
    },
    isItemPersonalizationDiscounted() {
      return DpIsPersonalizationDiscounted(this.item);
    },
    getPersonalizationAddon() {
      return this.item?.addons?.find((addon) => addon.type === 'personalization');
    },
    isItemFree() {
      return Number(this.item.subtotal) === 0;
    },
  },
  created() {
    window.addEventListener('resize', this.windowResize);
  },
  methods: {
    decrementQty() {
      this.removeThisItem({});
    },
    incrementQty(item) {
      if (this.order && this.order.id && this.order.petOwner && this.order.petOwner.id) {
        let details = {
          productId: item.product.id,
          petId: null,
        };
        this.$store
          .dispatch('order/addLocalItems', {
            vm: this,
            orderId: this.orderId,
            items: [details],
            fetchOrderOnSuccess: true,
          })
          .then(() => this.$emit('reloadSideBasket'));
      } else {
        const data = {
          style: this.$route.params.id,
          productId: item.product.id,
          color: item.product.color || null,
          petId: null,
          size: item.product.size || null,
        };
        this.$store.dispatch('order/storeLocalItems', { data: [data] }).then(() => this.$emit('reloadSideBasket'));
      }
    },
    size(str) {
      if (str == '0/T') return 'Extra Small';
      else if (str == '1/S') return 'Small';
      else if (str == '2/M') return 'Medium';
      else if (str == '3/L') return 'Large';
      else if (str == '4/X') return 'Extra Large';
      else 'N/A';
    },
    petEssentialsSize(str) {
      if (str == 'xs') return 'Extra Small';
      else if (str == 's') return 'Small';
      else if (str == 'm') return 'Medium';
      else if (str == 'l') return 'Large';
      else if (str == 'xl') return 'Extra Large';
      else 'N/A';
    },
    addChildItem() {
      if (this.child && this.personalization && this.addPersonalization && this.personalizationName) {
        this.personalizationLoading = true;
      }
      this.$emit('addChildItem', {
        item: this.item,
        child: this.child,
        personalization: this.personalization,
        personalizationName: !this.addPersonalization ? this.item?.group?.pet?.name?.substr(0, 9) : this.personalizationName,
        personalizationPhone: this.poPrimaryPhone,
      });
    },
    removeThisItem({ quantity = 1, confirm = false }) {
      if (this.item?.orderItemBundle) {
        if (confirm === false) {
          this.showRemoveBundleItemConfirmationModal(() => this.removeThisItem({quantity, confirm: true}));
          return;
        }
        this.$emit('remove-bundle');
      }
      this.$emit('removeItem', {
        item: this.item,
        child: this.child,
        personalization: this.personalization,
        quantity,
      });

      if (window?.dataLayer) {
        window?.dataLayer?.push({
          ecommerce: null,
        });
        const items = [];
        const _itemData = {
          quantity,
          coupon: this.order?.discount?.code || '',
          currency: `${this.order?.city?.country || 'US'}D`,
          item_list_id: this.item?.product?.style?.id || '',
          item_list_name: this.item?.product?.style?.code?.toUpperCase() || '',
        };
        if (this.item?.parent || this.personalization) {
          if (this.personalization && (this.item?.customTagOrderInfo || this.item?.customization)) {
            items.push({
              ..._itemData,
              item_id: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_name: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_category: 'PERSONALIZATION',
              price: Number(this.item?.customization || 0).toFixed(2),
            });
          } else {
            const _childData = {
              ..._itemData,
              item_list_id: this.item?.parent?.product?.style?.id || '',
              item_list_name: this.item?.parent?.product?.style?.code?.toUpperCase() || '',
              item_id: this.item?.product?.id || '',
              item_name: this.item?.product?.name?.toUpperCase() || '',
              item_category: this.item?.product?.type?.toUpperCase() || '',
              price: Number(this.item?.subtotal || 0).toFixed(2),
            };
            if (
              ['OTHER'].includes(this.item?.product?.type) ||
              (this.item?.product?.type === 'CONNECTOR' && this.item?.product?.id !== '207')
            ) {
              items.push(_childData);
            }
            if (this.item?.product?.type === 'DESIGNER_TAG' && this.item?.keyChain) {
              items.push({
                ..._childData,
                item_id: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_name: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_category: 'MATCHING_KEYCHAIN',
              });
            }
          }
        } else {
          this.item?.children?.forEach((child) => {
            const _childData = {
              ..._itemData,
              item_id: child.product?.id || '',
              item_name: child.product?.name?.toUpperCase() || '',
              item_category: child.product?.type?.toUpperCase() || '',
              price: Number(child.subtotal || 0).toFixed(2),
            };
            if (['OTHER'].includes(child.product?.type) || (child.product?.type === 'CONNECTOR' && child.product?.id !== '207')) {
              items.push(_childData);
            }
            if (child.product?.type === 'DESIGNER_TAG' && child.keyChain) {
              items.push({
                ..._childData,
                item_id: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_name: `${this.item?.product?.id}_MATCHING_KEYCHAIN`,
                item_category: 'MATCHING_KEYCHAIN',
              });
            }
          });
          if (this.item?.customTagOrderInfo || this.item?.customization) {
            items.push({
              ..._itemData,
              item_id: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_name: `${this.item?.product?.type?.toUpperCase()}_PERSONALIZATION`,
              item_category: 'PERSONALIZATION',
              price: Number(this.item?.customization || 0).toFixed(2),
            });
          }
          items.push({
            ..._itemData,
            item_id: this.item?.product?.id || '',
            item_name: this.item?.product?.name?.toUpperCase() || '',
            item_category: this.item?.product?.type?.toUpperCase() || '',
            price: Number(this.item?.subtotal || 0).toFixed(2),
          });
        }
        window.dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            items: items,
            currency: `${this.order?.city?.country || 'US'}D`,
            value: Number(items?.reduce((p, c) => p + Number(c.price), 0)).toFixed(2),
          },
          location: 'user_side_basket',
        });
      }

      this.maybeShowMembershipRemovalSurvey();
      this.maybeShowDesignerTagRemovalSurvey();
    },
    isMembershipItem() {
      return (
        this.item?.product?.type === 'SUBSCRIPTION' && this.item?.product?.productSubType === 'MEMBERSHIP'
      );
    },
    isDesignerTagItem() {
      return !this.child && this.item?.product?.type === 'DESIGNER_TAG';
    },
    maybeShowMembershipRemovalSurvey() {
      if (!this.isMembershipItem()) {
        return;
      }
      const shouldShow = DpShouldShowSurvey({
        enabled: this.$store.getters.getMembershipRemovalSurvey,
        surveyId: DP_MEMBERSHIP_REMOVAL_SURVEY_ID,
      });
      if (shouldShow) {
        this.showMembershipRemovalSurveyModal();
      }
    },
    maybeShowDesignerTagRemovalSurvey() {
      if (!this.isDesignerTagItem()) {
        return;
      }
      const shouldShow = DpShouldShowSurvey({
        enabled: this.$store.getters.getDesignerTagRemovalSurvey,
        surveyId: DP_DESIGNER_TAG_REMOVAL_SURVEY_ID,
      });
      if (shouldShow) {
        this.showDesignerTagRemovalSurveyModal();
      }
    },
    showMembershipRemovalSurveyModal() {
      const survey = new Vue({
        render: (h) =>
          h(DpSurveySubscriptionModal, {
            props: {
              surveyUrl: DP_MEMBERSHIP_REMOVAL_SURVEY_URL,
              title: this.$t('dp.survey.membershipRemoval.title'),
              closeLabel: this.$t('dp.survey.membershipRemoval.close'),
              show: true,
            },
            on: {
              close: () => {
                survey.$destroy();
                if (survey.$el && survey.$el.parentNode) {
                  survey.$el.parentNode.removeChild(survey.$el);
                }
              },
            },
          }),
      }).$mount();

      document.body.appendChild(survey.$el);
    },
    showDesignerTagRemovalSurveyModal() {
      const survey = new Vue({
        render: (h) =>
          h(DpSurveySubscriptionModal, {
            props: {
              surveyUrl: DP_DESIGNER_TAG_REMOVAL_SURVEY_URL,
              title: this.$t('dp.survey.designerTagRemoval.title'),
              closeLabel: this.$t('dp.survey.designerTagRemoval.close'),
              testId: 'survey-designer-tag-removal-modal',
              show: true,
            },
            on: {
              close: () => {
                survey.$destroy();
                if (survey.$el && survey.$el.parentNode) {
                  survey.$el.parentNode.removeChild(survey.$el);
                }
              },
            },
          }),
      }).$mount();

      document.body.appendChild(survey.$el);
    },
    getGlowTagProductId() {
      if (!this.item?.product?.color) return null;
      const GLOW_TAG_PRODUCT = {
        LG: '3284',
        SM_ALM: '3290',
        SM: '3291',
      };

      return this.item?.product?.size === '1/S'
        ? (this.item?.product?.material?.material === 'ALM' || (this.item?.product?.laserPrinterJig?.material === 'ALM'))
          ? GLOW_TAG_PRODUCT.SM_ALM
          : GLOW_TAG_PRODUCT.SM
        : GLOW_TAG_PRODUCT.LG;
    },
    showRemoveBundleItemConfirmationModal(confirmCallback) {
      const modalContainer = this.$refs.confirmationModal;

      if (modalContainer.childNodes.length) {
        modalContainer.childNodes.forEach((node) => node.remove());
      }

      new Vue({
        render: (h) => {
          let petName = this.item?.group?.pet?.name;
          let messageText = this.$t('sideBasket.removeBundleItemConfirmation.messageNoPet')

          if (petName) {
            messageText = this.$t('sideBasket.removeBundleItemConfirmation.message', {
              petName,
            })
          }

          return h(DpConfirmationModal, {
            props: {
              id: `remove-item-confirmation-${this.petId}`,
              title: this.$t('sideBasket.removeBundleItemConfirmation.title'),
              message: messageText,
              cancelButtonText: this.$t('sideBasket.removeBundleItemConfirmation.cancelButtonText'),
              confirmButtonText: this.$t('sideBasket.removeBundleItemConfirmation.confirmButtonText'),
              show: true,
            },
            on: {
              confirm: () => confirmCallback(),
              cancel: () => modalContainer.childNodes.forEach((node) => node.remove()),
            },
          });
        },
      }).$mount(modalContainer);
    },
    windowResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
::v-deep img {
  object-fit: contain;
}
::v-deep .img-border {
  border: solid 1px $dp-gray-4;
}
::v-deep .hr-lg {
  border-top: 2px solid $dp-gray-3;
}
::v-deep h5,
::v-deep .h5 {
  font-size: 0.9rem;
}
::v-deep .product {
  & h3,
  .product-name {
    color: $dp-gray-7;
  }
  .product-image {
    width: 90px;
    height: 90px;
    @media (max-width: 350px) {
      width: 60px;
      height: 60px;
    }
  }
}
</style>
